import {createChainableTypeChecker, PropTypeError} from "./ext";

export default function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        console.log(propValue);
        if (propValue === null) {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        if (propType !== 'object') {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        for (var key in shapeTypes) {
            var checker = shapeTypes[key];
            if (!checker) {
                continue;
            }
            var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
            if (error) {
                return error;
            }
        }
        return null;
    }
    return createChainableTypeChecker(validate);
}